var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhyGuard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 58,
    viewBox: "0 0 57 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8130_31848)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_8130_31848)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.7403 10.1839V25.8293C51.7403 40.0775 42.0644 52.5014 28.2433 56C14.4454 52.513 4.76953 40.0775 4.76953 25.8293V10.1839C15.6347 8.96 21.7889 4.82639 28.2549 0C34.7209 4.82639 40.8751 8.96 51.7403 10.1839Z",
    fill: "#E59311"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M28.2549 52C16.9924 48.425 9.25488 37.975 9.25488 26.025V14.55C17.1674 12.825 22.9799 9.6375 28.2549 6C33.6424 9.7375 39.3424 12.8625 47.2549 14.5625V26.0375C47.2549 37.975 39.5174 48.425 28.2549 52Z",
    fill: "#F9A623"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_8130_31848",
    x: 2.76953,
    y: 0,
    width: 50.9707,
    height: 60,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8130_31848"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_8130_31848",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8130_31848"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 58,
    fill: "white",
    transform: "translate(0.254883)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhyGuard);
export default __webpack_public_path__ + "static/media/phyGuard.38ecb15d2a8ae3287f86799e505a644d.svg";
export { ForwardRef as ReactComponent };